import { ThemeConfig, theme as _antdTheme } from 'antd';
import React, { useContext } from 'react';
import themeBase from 'admin/styles/_export.scss';

export const THEME = {
	LIGHT: 'light',
	DARK: 'dark',
} as const;

export type ThemeContext = { theme: ValuesType<typeof THEME> };
export const Context = React.createContext<ThemeContext>({ theme: THEME.LIGHT });
export const useTheme = () => useContext(Context);
export const ThemeProvider: React.FC<{ children: React.ReactNode; context: ThemeContext }> = props => {
	return <Context.Provider value={props.context}>{props.children}</Context.Provider>;
};

const antdThemeBase: ThemeConfig = {
	algorithm: _antdTheme.defaultAlgorithm,
	token: {
		colorPrimary: themeBase.baseColorBrand,
		colorSuccess: themeBase.baseColorBrandLight,
		colorText: themeBase.baseTextColor,
		colorSplit: themeBase.baseColorBlackSoft,
		fontFamily: themeBase.baseFontFamily,
		fontSize: 14,
		lineHeight: parseFloat(themeBase.baseLineHeight),
		borderRadius: parseInt(themeBase.baseBorderRadius, 10),
		borderRadiusOuter: parseInt(themeBase.baseBorderRadius, 10),
		borderRadiusXS: parseInt(themeBase.baseBorderRadius, 10),
	},
	components: {
		Slider: {
			// ...
		},
		Button: {
			primaryShadow: 'none',
		},
		Message: {
			contentBg: 'transparent',
			contentPadding: 0,
		},
	},
};

export const antdThemeLight: ThemeConfig = {
	...antdThemeBase,
	algorithm: _antdTheme.defaultAlgorithm,
};

export const antdThemeDark: ThemeConfig = {
	...antdThemeBase,
	algorithm: _antdTheme.darkAlgorithm,
	token: {
		...antdThemeBase.token,
		colorText: 'var(--ra-color-white-dark)',
		colorSplit: 'var(--ra-color-white-soft)',
	},
	components: {
		...antdThemeBase.components,
		Button: {
			...(antdThemeBase.components?.Button ?? {}),
			defaultBg: 'transparent',
			defaultHoverBg: 'transparent',
			defaultShadow: 'none',
		},
		Slider: {
			...(antdThemeBase.components?.Slider ?? {}),
			// Handles and dots are filled with the elevated background, which the dark algorithm makes near-black
			colorBgElevated: '#ffffff',
		},
	},
};
